<template>
  <div>
    <h2 v-if="signInPrompt" class="text-center">{{ signInPrompt }}</h2>
    <p v-if="bannerMessage" v-html="bannerMessage"></p>
    <div class="page-login-main">
      <form class="form-signin" :class="{ 'invalid': shakeForm }" name="signin" role="form">
        <section class="form-input-group">
          <b-form-group label="Email" label-for="email" class="mb-1" label-class="mb-0 text-muted" label-size="sm">
            <b-form-input v-model="email" class="form-control" name="email" id="email" maxlength="64" required
              autofocus></b-form-input>
          </b-form-group>

          <b-form-group label="Password" label-for="password" class="mb-1" label-class="mb-0 text-muted" label-size="sm">
            <b-form-input v-model="password" class="form-control" name="password" id="password" maxlength="64"
              type="password" required></b-form-input>
          </b-form-group>
        </section>
        <p v-if="helpText" id="help-text" class="form-feedback text-danger">{{ helpText }} <a v-if="showInvitationLink"
            :href="invitationLink">Click here to continue.</a></p>
        <button @click.prevent="login" type="submit" class="btn btn-primary btn-block mt-4 mb-4"
          :disabled="isDisabled">Sign in</button>
      </form>
    </div>
  </div>
</template>

<script>
import DataService from '../services/DataService'
import { subscribeToLogoutEvent } from "../helpers/handleLogoutEvent"
import { PusherService } from "../services/PusherService";
import { analyticsTrack, setAnalyticsUser, setBugsnagUser } from '../helpers/utils';
import { getUserProperties } from '../helpers/analytics';
const ds = DataService.getInstance()

export default {
  name: 'LoginCard',
  props: {
    signInPrompt: String,
    bannerMessage: String
  },
  data() {
    return {
      email: '',
      helpText: '',
      password: '',
      isDisabled: false,
      shakeForm: false,
      invitationLink: '',
      showInvitationLink: false
    }
  },
  async created() {
    ga('set', 'page', '/login.html');
    ga('send', 'pageview');
    this.$store.dispatch('settings/getAppSettings')
    // Assuming if we are coming to the login page then we are no more logged in
    PusherService.getInstance().unsubscribeFromAllChannel()
  },
  methods: {
    async login() {
      const username = this.email.toLowerCase().trim();
      const password = this.password
      try {
        this.isDisabled = true
        const user = await ds.getUser(username, password)
        // Subscribe to the pusher logout event
        subscribeToLogoutEvent();
        setBugsnagUser(user);
        analyticsTrack('Sign In');
        setAnalyticsUser(user);
        this.$emit('onSignin', user);
        this.$posthog.identify(user.id, getUserProperties(user));
      } catch (err) {
        if (err?.message?.invitationLink) {
          this.helpText = err.message.text;
          this.showInvitationLink = true;
          this.invitationLink = err.message.invitationLink;
        } else {
          let message = err;
          try {
            message = message?.replace("username/email", "email");
            message = message?.replace("username", "email");
            message = message?.charAt(0).toUpperCase() + message?.slice(1);
          } catch (e) {
            console.error(e);
          }

          this.helpText = message
          this.shakeForm = true
          setTimeout(() => {
            this.shakeForm = false
          }, 500)
        }
      } finally {
        this.isDisabled = false
      }
    },
    setHelpText(text) {
      this.helpText = text
    }
  }
}
</script>

<style></style>